import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import { faUnlockAlt } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useJoinUrl } from './JoinButton';

type Props = {
  className?: string;
  mainTitle?: ReactNode;
  topTitle: ReactNode;
};

export const PurchaseButton = (props: Props) => {
  const { topTitle, mainTitle = 'Get Full Site Access', className = '' } = props;
  const [joinHref] = useJoinUrl({ campaign: 'gallery-purchase-panel' });

  return (
    <Button href={joinHref} className={`btn btn-block ${className}`} data-tagmanager-event="join_cta">
      <Icon>
        <FontAwesomeIcon icon={faUnlockAlt} />
      </Icon>
      <TopTitle>{topTitle}</TopTitle>
      {mainTitle}
    </Button>
  );
};

const Button = styled.a`
  &&.btn {
    border-width: 1px;
    border-style: solid;
    font-size: 1.4rem;
    padding-left: 60px;
    color: #fff !important;
    background-color: #56c12b;
    border-color: #008000;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
    max-width: 340px;
  }
`;

const Icon = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.3);
`;

const TopTitle = styled.span`
  font-size: 0.7rem;
  display: block;
  font-weight: normal;
`;
